import { APP_BASE_HREF } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { AuditorService } from '@app/_core/services/auditor.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { FilteredInteractionsList } from '@app/_entities/filtered-list';
import { FilterDialogComponent } from '@app/pages/common/filter-dialog/filter-dialog.component';
import { ShowHideDialogComponent } from '@app/pages/common/show-hide-dialog/show-hide-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { TableLazyLoadEvent } from 'primeng/table';
import { catchError, empty, EMPTY, map } from 'rxjs';

import { SecurityService } from './../../../_core/services/security.service';
import { InteractionDetailsComponent } from './interaction-details/interaction-details.component';
import { forEach } from 'underscore';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-interactions',
  templateUrl: './interactions.component.html',
  styleUrls: ['./interactions.component.scss'],
})
export class InteractionsComponent implements OnInit{
  company: string = '';
  isAIAudits: any;
  constructor(
    private cdr: ChangeDetectorRef,
    private utils: Utils,
    private appService: AppService,
    private auditorService: AuditorService,
    private securityService: SecurityService,
    private webStorage: WebStorageService,
    private router: Router,
    private modalService: BsModalService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private sanitizer: DomSanitizer
  ) {}
  currentMenu: any = {};
  action = '';
  innerHeight = 10;
  showTable: boolean = true;
  showCrud: boolean = false;
  showDateRange: boolean = true;
  first = 0;
  totalRecords: number;
  loading: boolean;
  modalRef?: BsModalRef;
  interactionList: any = [];
  localStorageName = 'InteractionsColumnDisplaySettings';
  headercount: any = { shown: 0, hidden: 0 };
  filteredList = new FilteredInteractionsList();
  selectedFilterByField: any = '';
  filterVal: any = '';
  dispositionVal: any = '';
  filteredData: any = [];
  interactionsListData: any = [];
  isAudit: boolean = false;
  /*globalfilter*/
  findOptions: any = [
    // { value: 'ID', label: 'ID' },
    // { value: 'Agent', label: 'Agent' },
    // { value: 'Type', label: 'Type' },
    // { value: 'Group', label: 'Group' },
    // { value: 'Manager', label: 'Manager', format: 'value' },
    // { value: 'Queue', label: 'Queue' },
    // { value: 'Disposition', label: 'Disposition' },
    // { value: 'DispositionType', label: 'Disposition Type' },
    // { value: 'Audits', label: 'Audits' },
    { value: 'FirstName', label: 'Agent First Name' },
    { value: 'LastName', label: 'Agent Last Name' },
    { value: 'User', label: 'User' },
    { value: 'Company', label: 'Company' },
    { value: 'InteractionID', label: 'Interaction ID' },
    //{ value: 'CaseID', label: 'Case ID' },
    { value: 'CrmCaseID', label: 'CrmCase ID' },
  ];

  rowOffset = 0;
  rowCount = 10;
  searchField: any = { label: '', value: '' };
  searchValue: any = '';
  filterDict: any = [];
  sortColumn = 'Date';
  sortDescend = true;
  filterOptionRequestColumn = null;
  fromDate: Date = new Date();
  toDate: Date = new Date();
  pl: any = {};
  isAuditor: boolean = false;
  cols: any = [
    { name: 'ID', label: 'ID', showFilter: false, minWidth: 6 },
    { name: 'CaseID', label: 'Case ID', showFilter: false, minWidth: 6 },
    { name: 'CrmCaseID', label: 'CrmCase ID', showFilter: true, minWidth: 8 },
    { name: 'Agent', label: 'Agent', showFilter: true, minWidth: 7 },
    { name: 'Type', label: 'Type', showFilter: true, minWidth: 7 },
    { name: 'Group', label: 'Group', showFilter: true, minWidth: 7 },
    { name: 'Manager', label: 'Manager', showFilter: true, format: 'name', minWidth: 7 },
    { name: 'Queue', label: 'Queue', showFilter: true, minWidth: 9 },
    { name: 'User', label: 'User', minWidth: 9 },
    { name: 'Company', label: 'Company', minWidth: 7 },
    { name: 'Disposition', label: 'Disposition', showFilter: true, minWidth: 7 },
    // { name: 'DispositionType', label: 'Disposition Type', showFilter: true, minWidth: 9 },
    {
      name: 'HandlingTime',
      label: 'Handling Time',
      type: 'numeric',
      format: 'duration',
      minWidth: 9,
    },
    {
      name: 'Audits',
      label: 'Audits',
      showFilter: true,
      sortable: false,
      format: 'html',
      minWidth: 8,
    },
    {
      name: 'Recording',
      label: 'Recordings',
      showFilter: true,
      sortable: false,
      format: 'html',
      minWidth: 8,
    },
    { name: 'Date', label: 'Date', type: 'date', minWidth: 7 },
  ];
  //loadInteractionsTimeout: any;
  ngOnInit(): void {
    const clientAbbreviation = Utils.fetch('clientAbbreviation') || '';
    this.isAuditor = this.securityService.validateGrant('AuditAgents');
    this.isAIAudits = JSON.parse(Utils.fetch('IsAIAudits'));
    if (this.isAIAudits && this.isAuditor) {
      this.router.navigate([clientAbbreviation + '/Console/Auditing/AIInteractions']);
    }
    this.fromDate.setMonth(this.fromDate.getMonth() - 6);
   // this.fromDate.setFullYear(this.fromDate.getFullYear() - 1);
    this.pl = {
      rowOffset: 0,
      rowCount: 10,
      filterOptionRequestColumn: this.filterOptionRequestColumn,
      searchValue: this.searchValue,
      searchField: this.searchField.value,
      filterDict: this.filterDict,
      sortColumn: this.sortColumn,
      sortDescend: this.sortDescend,
      currentUserOnly: false,
      isExport: false,
      filter: {
        FromDate: new Date(this.fromDate).getTime(),
        ToDate: new Date(this.toDate).getTime(),
      },
    };
    this.appService.currentMenu.subscribe((val: boolean) => {
      this.currentMenu = val;
      this.action = this.currentMenu?.name;
    });

    this.searchField = this.findOptions[0];
    this.initializeColumnHeader();
    //this.loadInteractions();
    this.company = this.webStorage.getItemFromSessionStorage('company');
  }
  buildInteractionsPayload(rowOffset: number, rowCount: number, filterOptionRequestColumn: string | null) {
    return {
      rowOffset,
      rowCount,
      filterOptionRequestColumn,
      searchValue: this.searchValue,
      searchField: this.searchField?.value || '',
      filterDict: this.filterDict,
      sortColumn: this.sortColumn,
      sortDescend: this.sortDescend,
      currentUserOnly: false,
      isExport: false,
      filter: {
        FromDate: new Date(this.fromDate).getTime(),
        ToDate: new Date(this.toDate).getTime(),
      },
    };
  }
  formatTime(time: any) {
    return this.utils.formatTime(time);
  }
  applySelectedDateRange(val) {
    this.toDate = val.toDate;
    this.fromDate = val.fromDate;
    this.loadInteractions(null);
  }
  resetDateRange(event: any) 
  {
    this.fromDate = event.fromDate;
    this.toDate = event.toDate;
    this.loadInteractions(null);
  }

  // resetDateRange() {
  //   this.toDate = new Date();
  //   this.fromDate = new Date();
  //   this.fromDate.setFullYear(this.fromDate.getFullYear() - 1);
  //   this.loadInteractions(null);

  // }

  initializeColumnHeader() {
    const localCol = this.webStorage.getItemFromLocalStorage(this.localStorageName);
    if (localCol != null) {
      this.cols = localCol;
    } else {
      for (const col of this.cols) {
        col.hide = false;
      }
    }
    
    // Always update isAsc property based on current sort state
    for (const col of this.cols) {
      if (col.name == this.sortColumn) {
        if (this.sortDescend) {
          col.isAsc = false;
        } else {
          col.isAsc = true;
        }
      } else {
        delete col.isAsc;
      }
    }
    
    this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    this.getColumnCount();
  }

  getColumnCount() {
    let shown = 0;
    let hidden = 0;
    for (const header of this.cols) {
      if (header.hide) {
        hidden++;
      } else {
        shown++;
      }
    }
    this.headercount.shown = shown;
    this.headercount.hidden = hidden;
  }

  /*globalFilter*/
  clearSearchBox() {
    this.searchValue = '';
    this.searchField = { label: '', value: '' };
    //this.pl['searchField'] = { label: '', value: '' };
    this.loadInteractions(null);
    // this.searchValue = '';
    // this.pl['searchField'] = { label: '', value: '' };
    // this.filteredData = this.interactionsListData;
    // this.interactionList = this.applyColumnFilters(this.interactionsListData);
  }
  clearFilter() {
    // Clear all column filter values
    this.cols.forEach((col: any) => {
      delete col.filterVals;
    });
    
    // Clear the filter dictionary
    this.filterDict = [];
    
    this.loadInteractions(null);
  }
  applyFilterByField(val) {
    this.searchField = val.searchField;
    this.searchValue = val.searchValue;
    this.pl.searchField = this.searchField.value;
    this.pl.searchValue = this.searchValue;
    this.loadInteractions(null);
    // this.selectedFilterByField = val.searchField;
    // this.filterVal = val.searchValue;
    // if (this.selectedFilterByField.value != '' && this.filterVal != '') {
    //   this.filteredData = this.findByMatchingProperties(
    //     this.interactionsListData,
    //     this.selectedFilterByField,
    //     this.filterVal
    //   );
    //   this.interactionList = this.applyColumnFilters(this.filteredData);
    // }
  }

  findByMatchingProperties(set: any, properties: any, searchText: string) {
    return set.filter((entry: any) => {
      //alert(typeof(entry[properties.value]))
      if (typeof entry[properties.value] === 'number') {
        if (entry[properties.value].toString() == searchText) {
          return entry;
        }
      } else if (entry[properties.value].toString().includes(searchText)) return entry;
    });
  }
  /*column filter* starts here*/
  toggleCustomColumnFilter(colName: string) {
    this.filterOptionRequestColumn = colName;
    this.loadInteractions(null);
  }

  showColumnFilterModal(colName: string) {
    this.cdr.detectChanges();
    this.getColDetails(this.cols, this.filteredList);

    const initialState = {
      cols: this.cols,
      colName: colName,
    };

    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };
    this.modalRef = this.modalService.show(FilterDialogComponent, config);
    this.modalRef.content.event.subscribe((result: any) => {
      this.cols = result.data;
      this.cdr.detectChanges();
      //this.storeFilteredList(this.cols, colName);
      this.applyColumnFilters();
    });
  }

  storeFilteredList(colData, colName) {
    switch (colName) {
      case 'ID':
        this.filteredList.id = colData.filterVals;
        break;
      case 'Agent':
        this.filteredList.agent = colData.filterVals;
        break;
      case 'Type':
        this.filteredList.type = colData.filterVals;
        break;
      case 'Group':
        this.filteredList.group = colData.filterVals;
        break;
      case 'Manager':
        this.filteredList.manager = colData.filterVals;
        break;
      case 'Queue':
        this.filteredList.queue = colData.filterVals;
        break;
      case 'Disposition':
        this.filteredList.disposition = colData.filterVals;
        break;
      case 'DispositionType':
        this.filteredList.dispositionType = colData.filterVals;
        break;
      case 'Audits':
        this.filteredList.audits = colData.filterVals;
        break;
      case 'Recording':
        this.filteredList.recording = colData.filterVals;
        break;
    }
  }

  getFilteredList(colName) {
    switch (colName) {
      case 'ID':
        return this.filteredList.id;
      case 'Agent':
        return this.filteredList.agent;
      case 'Type':
        return this.filteredList.type;
      case 'Group':
        return this.filteredList.group;
      case 'Manager':
        return this.filteredList.manager;
      case 'Queue':
        return this.filteredList.queue;
      case 'Disposition':
        return this.filteredList.disposition;
      case 'DispositionType':
        return this.filteredList.dispositionType;
      case 'Audits':
        return this.filteredList.audits;
      case 'Recording':
        return this.filteredList.recording;
    }
    return null;
  }
  getColDetails(cols, filteredList) {
    if (filteredList) {
      for (const col of cols) {
        if (col.name == 'ID') {
          if (filteredList.id.length > 0) {
            col.filterVals = filteredList.id;
          }
        }
        if (col.name == 'Agent') {
          if (filteredList.agent.length > 0) {
            col.filterVals = filteredList.agent;
          }
        }
        if (col.name == 'Type') {
          if (filteredList.type.length > 0) {
            col.filterVals = filteredList.type;
          }
        }
        if (col.name == 'Group') {
          if (filteredList.group.length > 0) {
            col.filterVals = filteredList.group;
          }
        }
        if (col.name == 'Manager') {
          if (filteredList.manager.length > 0) {
            col.filterVals = filteredList.manager;
          }
        }
        if (col.name == 'Queue') {
          if (filteredList.queue.length > 0) {
            col.filterVals = filteredList.queue;
          }
        }
        if (col.name == 'Disposition') {
          if (filteredList.disposition.length > 0) {
            col.filterVals = filteredList.disposition;
          }
        }
        if (col.name == 'DispositionType') {
          if (filteredList.dispositionType.length > 0) {
            col.filterVals = filteredList.dispositionType;
          }
        }
        if (col.name == 'Audits') {
          if (filteredList.audits.length > 0) {
            col.filterVals = filteredList.audits;
          }
        }
        if (col.name == 'Recording') {
          if (filteredList.recording.length > 0) {
            col.filterVals = filteredList.recording;
          }
        }
      }
    }
  }

  /*column level filter*/
  applyColumnFilters() {
    // Don't clear filterDict - we need to preserve multiple column filters
    // Instead, rebuild it by going through all columns and their current state
    
    this.filterOptionRequestColumn = null;
    
    // Rebuild filterDict based on current column states
    const newFilterDict = [];
    
    for (const colData of this.cols) {
      const filterVals: string[] = [];
      if (colData.filterVals && colData.filterVals.length > 0) {
        for (const val of colData.filterVals) {
          if (val.checked) {
            filterVals.push(val.name.toString());
          }
        }
        // Only add to filterDict if there are actually selected values
        if (filterVals.length > 0) {
          newFilterDict.push({ Key: colData.name, Value: filterVals });
        }
      }
    }
    
    // Replace the entire filterDict with the new one to ensure consistency
    this.filterDict = newFilterDict;
    this.pl.filterDict = this.filterDict;

    this.loadInteractions(null);
    //this.interactionList = this.filterDict();
    //let records;
    //this.filterDict = [];
    //this.filterOptionRequestColumn = null;
    // for (const colData of this.cols) {
    //   const filterVals: any = [];
    //   if (colData.filterVals && colData.filterVals.length > 0) {
    //     for (const val of colData.filterVals) {
    //       if (val.checked) {
    //         filterVals.push(val.name);
    //       }
    //     }
    //     records = this.filterBySelectedFieldValues(records, colData.name, filterVals);
    //     // this.filterDict = [];
    //     // this.filterDict.push({ Key: colData.name, Value: filterVals });
    //   }
    // }
    // return records;
    //this.loadInteractions(null);
  }

  filterBySelectedFieldValues(set: any, properties: string, searchText: []) {
    if (searchText.length > 0) {
      return set.filter((entry: any) => {
        for (const search of searchText) {
          if (entry[properties].toString() == search) {
            return entry;
          }
        }
      });
    } else {
      return set;
    }
  }

  showHideColumns() {
    const initialState = {
      headerNames: this.cols,
      localStorageName: this.localStorageName,
    };

    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };

    this.modalRef = this.modalService.show(ShowHideDialogComponent, config);

    this.modalRef.content.event.subscribe((result: any) => {
      this.initializeColumnHeader();
    });
  }
  sortByColumn(colName: string) {
    this.sortColumn = colName;
    this.sortDescend = !this.sortDescend;
    
    // Update column isAsc property for sort icon display
    for (const col of this.cols) {
      if (col.name == this.sortColumn) {
        col.isAsc = !this.sortDescend;
      } else {
        delete col.isAsc;
      }
    }
    
    //this.cols = this.utils.sortByFieldInServer(colName, this.cols);
    this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    this.loadInteractions(null);
  }

  onRowSelect(event: any) {
    this.isAudit = this.securityService.validateGrant('AuditAgents');
    const row = event?.data ?? {};
    const hasAudits = this.hasAnyAudit(row);
    if (this.isAudit == true) 
      {
      const initialState = 
      {
        interactionId: event.data.ID,
      };
      const config: ModalOptions = {
        backdrop: 'static',
        class: 'interactionDetails-Auditmenu',
        initialState,
      };
      this.modalRef = this.modalService.show(InteractionDetailsComponent, config);
    } 
    else if (hasAudits == true && !this.isAudit && !row.EvaluationOwner)
    {
        this.auditorService.GetSurveysGroupedByDefinition(row.ID).subscribe((res: any) => {
        const list = res?.Response?.Data ?? [];
        const firstSurveyDefinition = list.find(d => d?.Surveys?.length > 0);
        const status = firstSurveyDefinition?.Surveys?.[0]?.Status?.Name ?? null;
        const modalClass =
          status === 'Submitted'
              ? 'interactionDetails-Auditmenu'
              : 'interactionDetails-menu';
          const initialState = {
            interactionId: row.ID,
            hasAudits,
          };
      
          const config: ModalOptions = {
            backdrop: 'static',
            class: modalClass,
            initialState,
          };
          this.modalRef = this.modalService.show(InteractionDetailsComponent, config);
          if (this.modalRef.content.OnHide) {
            this.modalRef.content.OnHide.subscribe(() => {
              this.loadInteractions({
                first: this.first,
                rows: 10
              });
            });
          }
      
        });
      }
      
    else if (hasAudits == true) 
      {
      const initialState = 
      {
        interactionId: event.data.ID,
        hasAudits,
      };
      const config: ModalOptions = {
        backdrop: 'static',
        class: 'interactionDetails-Auditmenu',
        initialState,
      };
      this.modalRef = this.modalService.show(InteractionDetailsComponent, config);
    }
    else {
      const initialState = {
        interactionId: event.data.ID,
      };
      const config: ModalOptions = {
        backdrop: 'static',
        class: 'interactionDetails-menu',
        initialState,
      };
      this.modalRef = this.modalService.show(InteractionDetailsComponent, config);
    }

    if (this.modalRef.content.OnHide) {
      this.modalRef.content.OnHide.subscribe((result: any) => {
      this.loadInteractions({
          first: this.first,
          rows: 10
      });
    });
    }
    // this.router.navigateByUrl(this.router.url + "/Details/" + event.data.ID)
  }

  loadInteractions(event: TableLazyLoadEvent) {
    if(this.isAIAudits && this.isAuditor){
      return;
    }
    this.loading = true;

    let rowOffset = this.rowOffset;
    let rowCount = this.rowCount;
    if (event == null) {
      this.resetTable();
    } else {
      this.first = event.first;
      rowOffset = event.first ?? this.rowOffset;
      rowCount = event.rows ?? this.rowCount;
    }

    const payload = this.buildInteractionsPayload(rowOffset, rowCount, this.filterOptionRequestColumn);

    this.auditorService
      .GetInteractions(payload)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetInteractions');
          if (isValid) {
            if (payload.filterOptionRequestColumn != null) {
              const columnName = payload.filterOptionRequestColumn;
              this.filterOptionRequestColumn = null;
              
              // Get existing checked values for this column before resetting
              const existingCol = this.cols.find(col => col.name === columnName);
              const existingCheckedValues = existingCol && existingCol.filterVals ? 
                existingCol.filterVals.filter(val => val.checked).map(val => val.name) : [];
              
              const filterVals = [];
              for (const dt of data.Response.Data) {
                if (dt != null && dt.trim() != '') {
                  // Preserve the checked state if this value was previously selected
                  const isChecked = existingCheckedValues.includes(dt);
                  filterVals.push({ name: dt, checked: isChecked });
                }
              }
              for (const col of this.cols) {
                if (col.name == columnName) {
                  col.filterVals = filterVals;
                }
              }
              this.showColumnFilterModal(columnName);
            } else {
              this.interactionList = data.Response.Data.Data;
              this.interactionsListData = this.interactionList;

              if (this.company?.toLowerCase() !== "covermytest") {
              //   this.cols = this.cols.filter(col => col.name !== 'CaseID');
              //   this.findOptions = this.findOptions.filter(fin => fin.value !== 'CaseID');
              // }else{
                this.cols = this.cols.filter(col => col.name !== 'CrmCaseID');
                this.findOptions = this.findOptions.filter(fin => fin.value !== 'CrmCaseID');
              }

              data.Response.Data.Data.forEach(element => {
                // if (element.CaseID == 0) {
                //   element.CaseID = '';
                // }
                if (!element.CrmCaseID) {
                  element.CrmCaseID = '';
                }

                if (element.HandlingTime <= 0) {
                  element.HandlingTime = '';
                }
                if (element.CaseID == 0) {
                  element.CaseID = '';
                }
                //element.Company = this.sanitizer.bypassSecurityTrustHtml(element.company);
              });

              if (data.Response.Data.TotalFilteredItems) {
                this.totalRecords = data.Response.Data.TotalFilteredItems;
              } else {
                this.totalRecords = 0;
              }
              this.loading = false;
            }
            //trigger change detection
            event?.forceUpdate?.();
            this.setInnerWidthHeightParameters();
          } else {
          }
        }),
        catchError(error => {
          this.loading = false;
          return EMPTY;
        })
      )
      .subscribe();
  }

  
  getModelText(value) {
    return this.sanitizer.bypassSecurityTrustHtml(this.decodeHtmlEntities(value));
  }
  decodeHtmlEntities(input: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = input;
    return txt.value;
  }

  setInnerWidthHeightParameters() {
    this.innerHeight = window.innerHeight * 0.07;
  }
  formatValue(col, row) {
    if (col.name == 'HandlingTime') {
      let handlingTime = row.HandlingTime < 0 ? 0 : row.HandlingTime;
      handlingTime = this.utils.formatDuration(handlingTime, 's', false, true, false);
      return '<div align="center" title="' + handlingTime + '">' + handlingTime + '</div>';
    } else if (col.name == 'Audits') {
      let audits = '<div align="center">';
      audits +=
        row.Scorecards != 0
          ? '<div class="iconButton iconStarHalf hideLabel' +
            (row.ScorecardOwner ? ' iconColorLit' : '') +
            '" title="Scorecards (' +
            row.Scorecards +
            ')"></div>'
          : '';
      audits +=
        row.Calibrations != 0
          ? '<div class="iconButton iconCompare hideLabel' +
            (row.CalibrationOwner ? ' iconColorLit' : '') +
            '" title="Calibrations (' +
            row.Calibrations +
            ')"></div>'
          : '';
      audits +=
        row.Evaluations != 0
          ? '<div class="iconButton iconThumbsUp hideLabel' +
            (row.EvaluationOwner ? ' iconColorLit' : '') +
            '" title="Evaluations (' +
            row.Evaluations +
            ')"></div>'
          : '';
      audits += '</div>';
      return audits;
    } else if (col.name == 'Recording') {
      let recording = '<div align="center">';
      recording += row.VideoRecording
        ? '<div class="iconButton iconVideo hideLabel" title="Video"><div>Video</div></div>'
        : '';
      recording += row.Recording ? '<div class="iconButton iconAudio hideLabel" title="Audio"><div></div></div>' : '';
      recording += row.Transcript
        ? '<div class="iconButton iconTranscript hideLabel" title="Transcript"><div>Transcript</div></div>'
        : '';
      recording += '</div>';
      return recording;
    }
    if (row[col.name] != null) {
      return '<div align="center" title="' + row[col.name] + '">' + row[col.name] + '</div>';
    } else {
      return '';
    }
  }
  renderAudits(row) {
    let audits = '<div align="center">';
    audits +=
      row.Scorecards != 0
        ? '<div class="iconButton iconStarHalf hideLabel' +
          (row.ScorecardOwner ? ' iconColorLit' : '') +
          '" title="Scorecards (' +
          row.Scorecards +
          ')"><div>Scorecards</div></div>'
        : '';
    audits +=
      row.Calibrations != 0
        ? '<div class="iconButton iconCompare hideLabel' +
          (row.CalibrationOwner ? ' iconColorLit' : '') +
          '" title="Calibrations (' +
          row.Calibrations +
          ')"><div>Calibrations</div></div>'
        : '';
    audits +=
      row.Evaluations != 0
        ? '<div class="iconButton iconThumbsUp hideLabel' +
          (row.EvaluationOwner ? ' iconColorLit' : '') +
          '" title="Evaluations (' +
          row.Evaluations +
          ')"><div>Evaluations</div></div>'
        : '';
    audits += '</div>';
    return audits;
  }

  renderRecording(row) {
    let recording = '<div align="center">';
    recording +=
      row.VideoRecording || row.VideoChatRecording
        ? '<div class="iconButton iconVideo hideLabel" title="' +
          (row.VideoRecording ? 'Video' : 'Video Chat') +
          '"><div>' +
          (row.VideoRecording ? 'Video' : 'Video Chat') +
          '</div></div>'
        : '';
    recording += row.Recording ? '<div class="iconButton iconAudio hideLabel" title="Audio"><div></div></div>' : '';
    recording += row.Transcript
      ? '<div class="iconButton iconTranscript hideLabel" title="Transcript"><div>Transcript</div></div>'
      : '';
    recording += '</div>';
    return recording;
  }

  resetTable() {
    this.first = 0;
    //this.interactionList = [];
    //this.totalRecords = 0;

    this.pl['rowOffset'] = this.rowOffset;
    this.pl['rowCount'] = this.rowCount;
    this.pl['filterDict'] = this.filterDict;
    this.pl['filterOptionRequestColumn'] = this.filterOptionRequestColumn;
    this.pl['filter'] = {
      FromDate: new Date(this.fromDate).getTime(),
      ToDate: new Date(this.toDate).getTime(),
    };
    this.pl['sortDescend'] = this.sortDescend;
    this.pl['sortColumn'] = this.sortColumn;
    this.pl['searchValue'] = this.searchValue;
    this.pl['searchField'] = this.searchField.value;
    this.pl['currentUserOnly'] = false;
    this.pl['isExport'] = false;

  }
  private hasAnyAudit(row: any): boolean 
  {
    return (row?.Scorecards ?? 0) > 0
        || (row?.Calibrations ?? 0) > 0
        || (row?.Evaluations ?? 0) > 0;
  }

  // ngOnDestroy(): void {
  //   this.loadInteractionsTimeout && clearTimeout(this.loadInteractionsTimeout);
  // }
}
